/**
 * Pinned kanban cards — a personal marker, kept in this browser only.
 *
 *   pins.has('board', 'card-1')     → boolean
 *   pins.toggle('board', 'card-1')  → true when it is now pinned
 *
 * A pin changes nothing about the record or the card's place in its column:
 * it is a highlight the viewer sets for themselves. Saved per page and board
 * in localStorage; unavailable storage (private mode, blocked) means pins last
 * until the page is left.
 */

const REGISTRY = Symbol.for('gainable.kanbanPins');

function reg() {
  const g = globalThis;
  if (!g[REGISTRY]) g[REGISTRY] = new Map();
  return g[REGISTRY];
}

function storageKey(key) {
  const path = (typeof location !== 'undefined' && location.pathname) || '';
  return `gainable:pins:${path}:${key}`;
}

function load(key) {
  const cache = reg();
  if (cache.has(key)) return cache.get(key);
  let ids = [];
  try {
    const raw = globalThis.localStorage && globalThis.localStorage.getItem(storageKey(key));
    const parsed = raw ? JSON.parse(raw) : [];
    if (Array.isArray(parsed)) ids = parsed.filter((x) => x != null && x !== '').map(String);
  } catch { /* nothing saved */ }
  const set = new Set(ids);
  cache.set(key, set);
  return set;
}

function save(key, set) {
  try {
    if (!globalThis.localStorage) return;
    if (set.size) globalThis.localStorage.setItem(storageKey(key), JSON.stringify([...set]));
    else globalThis.localStorage.removeItem(storageKey(key));
  } catch { /* not kept past this page — still works */ }
}

export const pins = {
  has(key, id) {
    return id != null && id !== '' && load(key).has(String(id));
  },
  toggle(key, id) {
    if (id == null || id === '') return false;
    const set = load(key);
    const sid = String(id);
    const pinned = !set.has(sid);
    if (pinned) set.add(sid); else set.delete(sid);
    save(key, set);
    return pinned;
  },
};
